const sourceChargeConstants = {
    validSourceChargerHeaders: {
        'Source Type*': 'source_type',
        'Source*': 'source',
        'Transporter Reference Id*': 'transporter_ref_id',
        Movement: 'movement',
        'Vehicle Type*': 'vehicle_type',
        'Charge Code': 'charge_code',
        'Slab Min': 'slab_min',
        'Slab Max': 'slab_max',
        'Slab Unit': 'slab_unit',
        Charge: 'charge',
        'Charge Unit': 'charge_unit',
        'Min Charge': 'min_charge',
    },
    exportAndRejectionHeaders: {
        'Source Type*': 'source_type',
        'Source*': 'source',
        'Transporter Reference Id*': 'transporter_ref_id',
        Movement: 'movement',
        'Vehicle Type*': 'vehicle_type',
        'Charge Code': 'charge_code',
        'Slab Min': 'slab_min',
        'Slab Max': 'slab_max',
        'Slab Unit': 'slab_unit',
        Charge: 'charge',
        'Charge Unit': 'charge_unit',
        'Min Charge': 'min_charge',
    },
  };

  module.exports = { sourceChargeConstants };